// import React, { useEffect, useMemo, useState } from 'react';
// import { 
//   Search, 
//   ArrowUpDown, 
//   CheckCircle, 
//   XCircle, 
//   Clock,
//   CreditCard,
//   User,
//   Phone,
//   IndianRupee,
//   Hash,
//   BarChart3, 
//   Users, 
//   TrendingUp, 
//   Award, 
//   ArrowUpCircle, 
//   ArrowDownCircle, 
//   Wallet, 
//   Shield 
// } from 'lucide-react';
// import { useAppDispatch, useAppSelector } from '../../slices/types';
// import { fetchManualDeposits, fetchManualDepositsStats, reviewManualDeposit, verifyPayxMintPayment, recheckPayxMintV2Payment, approvePayxMintV2Recovery, recoverPayxMintV2Wallet, manualApproveGatewayPayment, setActiveStatus, type ManualDeposit } from '../../slices/finance/manualDepositsSlice';

// const DepositRequest: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const { items, loading, activeStatus, stats } = useAppSelector((s) => s.ManualDeposits);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortField, setSortField] = useState<keyof ManualDeposit>('id');
//   const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
//   const [showFilters, setShowFilters] = useState(false);
//   const [filterData, setFilterData] = useState({
//     name: '',
//     mobile: '',
//     utr_number: '',
//     bet_status: 'all',
//     mode: 'all',
//     date_from: '',
//     date_to: ''
//   });

//   useEffect(() => {
//     dispatch(fetchManualDeposits({ status: activeStatus === 'all' ? undefined : activeStatus }));
//     dispatch(fetchManualDepositsStats());
//   }, [dispatch, activeStatus]);

//   const filteredRecords = useMemo(() => {
//     const list = items.filter(record => {
//       const matchesSearch =
//         record.user_mobile.includes(searchTerm) ||
//         record.utr_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         record.id.toString().includes(searchTerm);
      
//       const matchesName = !filterData.name || (record.user_account_name || '').toLowerCase().includes(filterData.name.toLowerCase());
//       const matchesMobile = !filterData.mobile || record.user_mobile.includes(filterData.mobile);
//       const matchesUtr = !filterData.utr_number || record.utr_number.toLowerCase().includes(filterData.utr_number.toLowerCase());
      
//       // Date filtering
//       const recordDate = new Date(record.created_at);
//       const fromDate = filterData.date_from ? new Date(filterData.date_from) : null;
//       const toDate = filterData.date_to ? new Date(filterData.date_to) : null;
      
//       const matchesDateFrom = !fromDate || recordDate >= fromDate;
//       const matchesDateTo = !toDate || recordDate <= toDate;
      
//       // Status filtering (mapping deposit status to bet status concept)
//       const matchesStatus = filterData.bet_status === 'all' || 
//         (filterData.bet_status === 'pending' && record.status === 'pending') ||
//         (filterData.bet_status === 'approved' && record.status === 'approved') ||
//         (filterData.bet_status === 'rejected' && record.status === 'rejected');
      
//       return matchesSearch && matchesName && matchesMobile && matchesUtr && 
//              matchesDateFrom && matchesDateTo && matchesStatus;
//     });
    
//     return list.sort((a: any, b: any) => {
//       const aValue = a[sortField];
//       const bValue = b[sortField];
//       return sortDirection === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue < bValue ? 1 : -1);
//     });
//   }, [items, searchTerm, sortField, sortDirection, filterData]);

//   const handleSort = (field: keyof ManualDeposit) => {
//     if (sortField === field) {
//       setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortField(field);
//       setSortDirection('asc');
//     }
//   };

//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case 'success':
//         return 'text-green-600 bg-green-50';
//       case 'pending':
//         return 'text-blue-600 bg-orange-50';
//       case 'rejected':
//         return 'text-red-600 bg-red-50';
//       default:
//         return 'text-gray-600 bg-gray-50';
//     }
//   };

//   const getStatusIcon = (status: string) => {
//     switch (status) {
//       case 'success':
//         return <CheckCircle className="w-4 h-4" />;
//       case 'pending':
//         return <Clock className="w-4 h-4" />;
//       case 'rejected':
//         return <XCircle className="w-4 h-4" />;
//       default:
//         return <Clock className="w-4 h-4" />;
//     }
//   };

//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const formatDate = (dateString: string) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit'
//     });
//   };

//   return (
//     <div className="p-6">
//       {/* Stats Cards */}
//       {stats && (
//         <div className="mb-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {/* Total Deposits */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <BarChart3 className="h-8 w-8 text-blue-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Total Deposits</p>
//                   <p className="text-2xl font-bold text-gray-900">{stats.overall?.total_deposits || 0}</p>
//                   <p className="text-xs text-gray-500">All Time</p>
//                 </div>
//               </div>
//             </div>

//             {/* Pending Deposits */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <Clock className="h-8 w-8 text-yellow-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Pending Deposits</p>
//                   <p className="text-2xl font-bold text-gray-900">{stats.overall?.pending_deposits || 0}</p>
//                   <p className="text-xs text-gray-500">Awaiting Review</p>
//                 </div>
//               </div>
//             </div>

//             {/* Approved Deposits */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <CheckCircle className="h-8 w-8 text-green-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Approved Deposits</p>
//                   <p className="text-2xl font-bold text-gray-900">{stats.overall?.approved_deposits || 0}</p>
//                   <p className="text-xs text-gray-500">Successfully Processed</p>
//                 </div>
//               </div>
//             </div>

//             {/* Rejected Deposits */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <XCircle className="h-8 w-8 text-red-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Rejected Deposits</p>
//                   <p className="text-2xl font-bold text-gray-900">{stats.overall?.rejected_deposits || 0}</p>
//                   <p className="text-xs text-gray-500">Not Approved</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Second Row - Amount Stats */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
//             {/* Total Amount */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <IndianRupee className="h-8 w-8 text-purple-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Total Amount</p>
//                   <p className="text-2xl font-bold text-gray-900">{formatAmount(stats.overall?.total_amount || 0)}</p>
//                   <p className="text-xs text-gray-500">All Deposits</p>
//                 </div>
//               </div>
//             </div>

//             {/* Pending Amount */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <ArrowUpCircle className="h-8 w-8 text-yellow-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Pending Amount</p>
//                   <p className="text-2xl font-bold text-gray-900">{formatAmount(stats.overall?.pending_amount || 0)}</p>
//                   <p className="text-xs text-gray-500">Awaiting Review</p>
//                 </div>
//               </div>
//             </div>

//             {/* Approved Amount */}
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <div className="flex items-center">
//                 <div className="flex-shrink-0">
//                   <TrendingUp className="h-8 w-8 text-green-600" />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-500 uppercase">Approved Amount</p>
//                   <p className="text-2xl font-bold text-gray-900">{formatAmount(stats.overall?.approved_amount || 0)}</p>
//                   <p className="text-xs text-gray-500">Successfully Processed</p>
//                 </div>
//               </div>
//             </div>

//             {/* Today Deposits card removed as requested */}
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <div className="mb-6">
//         <div className="flex items-center justify-between">
//           <h1 className="text-2xl font-bold text-gray-900">Deposit Request</h1>
//           <div className="flex items-center gap-2">
//             {(['all','pending','approved','rejected'] as const).map(s => (
//               <button key={s} onClick={() => dispatch(setActiveStatus(s))}
//                 className={`px-3 py-1 rounded text-sm border ${activeStatus===s?'bg-blue-600 text-white border-blue-600':'bg-white text-gray-700'}`}>
//                 {s[0].toUpperCase()+s.slice(1)}
//               </button>
//             ))}
//           </div>
//           <div className="flex items-center space-x-4">
//             <div className="relative">
//               <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-64"
//               />
//             </div>
//             <button
//               onClick={()=>setShowFilters(!showFilters)}
//               className="px-5 py-2.5 rounded text-xs bg-gray-600 text-white"
//             >Filters</button>
//           </div>
//         </div>
//       </div>

//       {/* Advanced Filters */}
//       {showFilters && (
//         <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
//               <input
//                 type="text"
//                 placeholder="Account holder name"
//                 value={filterData.name}
//                 onChange={(e)=>setFilterData(prev=>({...prev, name: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
//               <input
//                 type="text"
//                 placeholder="Mobile number"
//                 value={filterData.mobile}
//                 onChange={(e)=>setFilterData(prev=>({...prev, mobile: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">UTR Number</label>
//               <input
//                 type="text"
//                 placeholder="UTR number"
//                 value={filterData.utr_number}
//                 onChange={(e)=>setFilterData(prev=>({...prev, utr_number: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Bet Status</label>
//               <select
//                 value={filterData.bet_status}
//                 onChange={(e)=>setFilterData(prev=>({...prev, bet_status: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               >
//                 <option value="all">All Status</option>
//                 <option value="pending">Pending</option>
//                 <option value="approved">Approved</option>
//                 <option value="rejected">Rejected</option>
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Mode</label>
//               <select
//                 value={filterData.mode}
//                 onChange={(e)=>setFilterData(prev=>({...prev, mode: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               >
//                 <option value="all">All Modes</option>
//                 <option value="upi">UPI</option>
//                 <option value="imps_neft_rtgs">IMPS/NEFT/RTGS</option>
//                 <option value="qr">QR</option>
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Date From</label>
//               <input
//                 type="date"
//                 placeholder="dd-mm-yyyy"
//                 value={filterData.date_from}
//                 onChange={(e)=>setFilterData(prev=>({...prev, date_from: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Date To</label>
//               <input
//                 type="date"
//                 placeholder="dd-mm-yyyy"
//                 value={filterData.date_to}
//                 onChange={(e)=>setFilterData(prev=>({...prev, date_to: e.target.value}))}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//           </div>
//           <div className="mt-4 flex gap-3">
//             <button
//               onClick={()=>{
//                 const statusParam = filterData.bet_status === 'all' ? undefined : (filterData.bet_status as 'pending' | 'approved' | 'rejected');
//                 const modeParam = filterData.mode === 'all' ? undefined : (filterData.mode as 'upi' | 'imps_neft_rtgs' | 'qr');
//                 const dateFrom = filterData.date_from || undefined;
//                 const dateTo = filterData.date_to || undefined;
//                 dispatch(fetchManualDeposits({ status: statusParam, mode: modeParam, date_from: dateFrom, date_to: dateTo }));
//               }}
//               className="px-4 py-2 bg-blue-600 text-white rounded-lg"
//             >Apply Filters</button>
//             <button
//               onClick={()=>setFilterData({ 
//                 name:'', 
//                 mobile:'', 
//                 utr_number:'',
//                 bet_status: 'all',
//                 mode: 'all',
//                 date_from: '',
//                 date_to: ''
//               })}
//               className="px-4 py-2 bg-gray-600 text-white rounded-lg"
//             >Clear All</button>
//           </div>
//         </div>
//       )}

//       {/* Mode Breakdown */}
//       {stats?.mode_breakdown && Array.isArray(stats.mode_breakdown) && stats.mode_breakdown.length > 0 && (
//         <div className="mb-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {stats.mode_breakdown.map((m: { mode: string; count: number; total_amount: number }) => (
//               <div key={m.mode} className="bg-white rounded-lg shadow-sm border p-6">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0">
//                     {m.mode === 'upi' ? (
//                       <Wallet className="h-8 w-8 text-blue-600" />
//                     ) : m.mode === 'qr' ? (
//                       <Shield className="h-8 w-8 text-purple-600" />
//                     ) : (
//                       <CreditCard className="h-8 w-8 text-emerald-600" />
//                     )}
//                   </div>
//                   <div className="ml-4">
//                     <p className="text-sm font-medium text-gray-500 uppercase">{m.mode.replaceAll('_',' ').toUpperCase()}</p>
//                     <p className="text-2xl font-bold text-gray-900">{m.count}</p>
//                     <p className="text-xs text-gray-500">{formatAmount(m.total_amount)} total</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Table */}
//       <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('id')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>ID</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('user_account_name')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Name</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('user_mobile')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Phone</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('amount')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Amount</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   UTR
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('status')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Request Type</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('mode')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Deposit Mode</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('status')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Status</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Reviewed
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Action
//                 </th>
//                 <th 
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
//                   onClick={() => handleSort('created_at')}
//                 >
//                   <div className="flex items-center space-x-1">
//                     <span>Created At</span>
//                     <ArrowUpDown className="w-3 h-3" />
//                   </div>
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {filteredRecords.map((record, index) => (
//                 <tr key={record.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {record.id}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     <div className="flex items-center">
//                       <User className="w-4 h-4 text-gray-400 mr-2" />
//                       {record.user_account_name || '-'}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600">
//                     <div className="flex items-center">
//                       <Phone className="w-4 h-4 text-gray-400 mr-2" />
//                       {record.user_mobile}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     <div className="flex items-center">
//                       <IndianRupee className="w-4 h-4 text-gray-400 mr-2" />
//                       {formatAmount(Number(record.amount))}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     <div className="flex items-center">
//                       <Hash className="w-4 h-4 text-gray-400 mr-2" />
//                       <span className="font-mono text-xs">{record.utr_number}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     Credit
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     <div className="flex items-center">
//                       <CreditCard className="w-4 h-4 text-blue-500 mr-2" />
//                       {record.mode.toUpperCase()}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(record.status)}`}>
//                       {getStatusIcon(record.status)}
//                       <span className="ml-1">{record.status}</span>
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     {record.reviewed_by_role ? (
//                       <div className="flex items-center">
//                         <User className="w-4 h-4 text-gray-400 mr-2" />
//                         {record.reviewed_by_role}
//                       </div>
//                     ) : (
//                       <span className="text-gray-400">-</span>
//                     )}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                     {record.status === 'pending' ? (
//                       <div className="flex space-x-2">
//                         <button onClick={() => dispatch(reviewManualDeposit({ id: record.id, status: 'approved', admin_notes: 'Approved' }))}
//                           className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs">
//                           Approve
//                         </button>
//                         <button onClick={() => dispatch(reviewManualDeposit({ id: record.id, status: 'rejected', rejection_reason: 'Invalid UTR' }))}
//                           className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-3 py-1 rounded text-xs">
//                           Reject
//                         </button>
//                       </div>
//                     ) : (
//                       <span className="text-gray-500">No Action</span>
//                     )}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(record.created_at)}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DepositRequest;



import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { 
  Search, 
  ArrowUpDown, 
  CheckCircle, 
  XCircle, 
  Clock,
  CreditCard,
  User,
  Phone,
  IndianRupee,
  Hash,
  BarChart3, 
  Users, 
  TrendingUp, 
  Award, 
  ArrowUpCircle, 
  ArrowDownCircle, 
  Wallet, 
  Shield,
  Eye,
  Image as ImageIcon
} from 'lucide-react';
import { useAppDispatch, useAppSelector } from '../../slices/types';
import { fetchManualDeposits, fetchManualDepositsStats, reviewManualDeposit, verifyPayxMintPayment, recheckPayxMintV2Payment, approvePayxMintV2Recovery, recoverPayxMintV2Wallet, manualApproveGatewayPayment, setActiveStatus, type ManualDeposit } from '../../slices/finance/manualDepositsSlice';

const DepositRequest: React.FC = () => {
  const dispatch = useAppDispatch();
  const {
    items,
    loading,
    activeStatus,
    stats,
    count,
    next,
    previous,
  } = useAppSelector((s) => s.ManualDeposits);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState<keyof ManualDeposit>('id');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const [showFilters, setShowFilters] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [filterData, setFilterData] = useState({
    name: '',
    mobile: '',
    utr_number: '',
    bet_status: 'all',
    mode: 'all',
    date_from: '',
    date_to: ''
  });

  const refreshDeposits = useCallback(() => {
    const effectiveStatus =
      filterData.bet_status !== 'all'
        ? (filterData.bet_status as 'pending' | 'approved' | 'rejected')
        : activeStatus === 'all'
          ? undefined
          : activeStatus;

    const effectiveMode =
      filterData.mode === 'all'
        ? undefined
        : (filterData.mode as 'upi' | 'imps_neft_rtgs' | 'qr' | 'payxmint' | 'payxmint_v2' | 'ismartpay');

    dispatch(fetchManualDeposits({
      status: effectiveStatus,
      mode: effectiveMode,
      date_from: filterData.date_from || undefined,
      date_to: filterData.date_to || undefined,
      page,
      page_size: pageSize,
    }));

    dispatch(fetchManualDepositsStats());
  }, [
    dispatch,
    activeStatus,
    page,
    pageSize,
    filterData.bet_status,
    filterData.mode,
    filterData.date_from,
    filterData.date_to,
  ]);

  useEffect(() => {
    refreshDeposits();

    const refreshTimer = window.setInterval(refreshDeposits, 10000);

    return () => {
      window.clearInterval(refreshTimer);
    };
  }, [refreshDeposits]);

  const filteredRecords = useMemo(() => {
    const list = items.filter(record => {
      const matchesSearch =
        String(record.user_mobile ?? '').includes(searchTerm) ||
        String(record.utr_number ?? '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        record.id.toString().includes(searchTerm);
      
      const matchesName = !filterData.name || (record.user_account_name || '').toLowerCase().includes(filterData.name.toLowerCase());
      const matchesMobile = !filterData.mobile || String(record.user_mobile ?? '').includes(filterData.mobile);
      const matchesUtr = !filterData.utr_number || String(record.utr_number ?? '').toLowerCase().includes(filterData.utr_number.toLowerCase());
      
      // Match Django's Asia/Kolkata calendar dates.
      const recordDate = new Date(record.created_at);
      const recordDateIST = Number.isNaN(recordDate.getTime())
        ? ''
        : new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).formatToParts(recordDate);

      const istDate = typeof recordDateIST === 'string'
        ? ''
        : [
            recordDateIST.find(part => part.type === 'year')?.value,
            recordDateIST.find(part => part.type === 'month')?.value,
            recordDateIST.find(part => part.type === 'day')?.value,
          ].join('-');

      const matchesDateFrom =
        !filterData.date_from ||
        (istDate !== '' && istDate >= filterData.date_from);

      const matchesDateTo =
        !filterData.date_to ||
        (istDate !== '' && istDate <= filterData.date_to);
      
      // Status filtering (mapping deposit status to bet status concept)
      const matchesStatus = filterData.bet_status === 'all' || 
        (filterData.bet_status === 'pending' && record.status === 'pending') ||
        (filterData.bet_status === 'approved' && record.status === 'approved') ||
        (filterData.bet_status === 'rejected' && record.status === 'rejected');
      
      return matchesSearch && matchesName && matchesMobile && matchesUtr && 
             matchesDateFrom && matchesDateTo && matchesStatus;
    });
    
    return list.sort((a: any, b: any) => {
      const aValue = a[sortField];
      const bValue = b[sortField];
      if (aValue !== bValue) {
        if (aValue == null) return 1;
        if (bValue == null) return -1;

        if (aValue > bValue) {
          return sortDirection === 'asc' ? 1 : -1;
        }

        if (aValue < bValue) {
          return sortDirection === 'asc' ? -1 : 1;
        }
      }

      const idDifference = Number(b.id) - Number(a.id);
      if (idDifference !== 0) return idDifference;

      return String(a.request_type ?? '').localeCompare(
        String(b.request_type ?? '')
      );
    });
  }, [items, searchTerm, sortField, sortDirection, filterData]);

  const handleSort = (field: keyof ManualDeposit) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'success':
        return 'text-green-600 bg-green-50';
      case 'pending':
        return 'text-blue-600 bg-orange-50';
      case 'rejected':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'success':
        return <CheckCircle className="w-4 h-4" />;
      case 'pending':
        return <Clock className="w-4 h-4" />;
      case 'rejected':
        return <XCircle className="w-4 h-4" />;
      default:
        return <Clock className="w-4 h-4" />;
    }
  };

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="p-6">
      {/* Stats Cards */}
      {stats && (
        <div className="mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Total Deposits */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <BarChart3 className="h-8 w-8 text-blue-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Total Deposits</p>
                  <p className="text-2xl font-bold text-gray-900">{stats.overall?.total_deposits || 0}</p>
                  <p className="text-xs text-gray-500">All Time</p>
                </div>
              </div>
            </div>

            {/* Pending Deposits */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Clock className="h-8 w-8 text-yellow-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Pending Deposits</p>
                  <p className="text-2xl font-bold text-gray-900">{stats.overall?.pending_deposits || 0}</p>
                  <p className="text-xs text-gray-500">Awaiting Review</p>
                </div>
              </div>
            </div>

            {/* Approved Deposits */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Approved Deposits</p>
                  <p className="text-2xl font-bold text-gray-900">{stats.overall?.approved_deposits || 0}</p>
                  <p className="text-xs text-gray-500">Successfully Processed</p>
                </div>
              </div>
            </div>

            {/* Rejected Deposits */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <XCircle className="h-8 w-8 text-red-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Rejected Deposits</p>
                  <p className="text-2xl font-bold text-gray-900">{stats.overall?.rejected_deposits || 0}</p>
                  <p className="text-xs text-gray-500">Not Approved</p>
                </div>
              </div>
            </div>
          </div>

          {/* Second Row - Amount Stats */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
            {/* Total Amount */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <IndianRupee className="h-8 w-8 text-purple-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Total Amount</p>
                  <p className="text-2xl font-bold text-gray-900">{formatAmount(stats.overall?.total_amount || 0)}</p>
                  <p className="text-xs text-gray-500">All Deposits</p>
                </div>
              </div>
            </div>

            {/* Pending Amount */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <ArrowUpCircle className="h-8 w-8 text-yellow-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Pending Amount</p>
                  <p className="text-2xl font-bold text-gray-900">{formatAmount(stats.overall?.pending_amount || 0)}</p>
                  <p className="text-xs text-gray-500">Awaiting Review</p>
                </div>
              </div>
            </div>

            {/* Approved Amount */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <TrendingUp className="h-8 w-8 text-green-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500 uppercase">Approved Amount</p>
                  <p className="text-2xl font-bold text-gray-900">{formatAmount(stats.overall?.approved_amount || 0)}</p>
                  <p className="text-xs text-gray-500">Successfully Processed</p>
                </div>
              </div>
            </div>

            {/* Today Deposits card removed as requested */}
          </div>
        </div>
      )}

      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Deposit Request</h1>
          <div className="flex items-center gap-2">
            {(['all','pending','approved','rejected'] as const).map(s => (
              <button
                key={s}
                onClick={() => {
                  setPage(1);
                  dispatch(setActiveStatus(s));
                }}
                className={`px-3 py-1 rounded text-sm border ${activeStatus===s?'bg-blue-600 text-white border-blue-600':'bg-white text-gray-700'}`}>
                {s[0].toUpperCase()+s.slice(1)}
              </button>
            ))}
          </div>
          <div className="flex items-center space-x-4">
            <div className="relative">
              <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-64"
              />
            </div>
            <button
              onClick={()=>setShowFilters(!showFilters)}
              className="px-5 py-2.5 rounded text-xs bg-gray-600 text-white"
            >Filters</button>
          </div>
        </div>
      </div>

      {/* Advanced Filters */}
      {showFilters && (
        <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              <input
                type="text"
                placeholder="Account holder name"
                value={filterData.name}
                onChange={(e)=>setFilterData(prev=>({...prev, name: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
              <input
                type="text"
                placeholder="Mobile number"
                value={filterData.mobile}
                onChange={(e)=>setFilterData(prev=>({...prev, mobile: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">UTR Number</label>
              <input
                type="text"
                placeholder="UTR number"
                value={filterData.utr_number}
                onChange={(e)=>setFilterData(prev=>({...prev, utr_number: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Bet Status</label>
              <select
                value={filterData.bet_status}
                onChange={(e)=>setFilterData(prev=>({...prev, bet_status: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mode</label>
              <select
                value={filterData.mode}
                onChange={(e)=>setFilterData(prev=>({...prev, mode: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="all">All Modes</option>
                <option value="upi">UPI</option>
                <option value="imps_neft_rtgs">IMPS/NEFT/RTGS</option>
                <option value="qr">QR</option>
                <option value="payxmint">PayxMint</option>
                <option value="payxmint_v2">PayxMint V2</option>
                <option value="ismartpay">iSmartPay</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date From</label>
              <input
                type="date"
                placeholder="dd-mm-yyyy"
                value={filterData.date_from}
                onChange={(e)=>setFilterData(prev=>({...prev, date_from: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date To</label>
              <input
                type="date"
                placeholder="dd-mm-yyyy"
                value={filterData.date_to}
                onChange={(e)=>setFilterData(prev=>({...prev, date_to: e.target.value}))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
          <div className="mt-4 flex gap-3">
            <button
              onClick={()=>{
                const statusParam = filterData.bet_status === 'all' ? undefined : (filterData.bet_status as 'pending' | 'approved' | 'rejected');
                const modeParam = filterData.mode === 'all' ? undefined : (filterData.mode as 'upi' | 'imps_neft_rtgs' | 'qr' | 'payxmint' | 'payxmint_v2' | 'ismartpay');
                const dateFrom = filterData.date_from || undefined;
                const dateTo = filterData.date_to || undefined;
                setPage(1);

                dispatch(fetchManualDeposits({
                  status: statusParam,
                  mode: modeParam,
                  date_from: dateFrom,
                  date_to: dateTo,
                  page: 1,
                  page_size: pageSize,
                }));
              }}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg"
            >Apply Filters</button>
            <button
              onClick={()=>setFilterData({ 
                name:'', 
                mobile:'', 
                utr_number:'',
                bet_status: 'all',
                mode: 'all',
                date_from: '',
                date_to: ''
              })}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg"
            >Clear All</button>
          </div>
        </div>
      )}

      {/* Mode Breakdown */}
      {stats?.mode_breakdown && Array.isArray(stats.mode_breakdown) && stats.mode_breakdown.length > 0 && (
        <div className="mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {stats.mode_breakdown.map((m: { mode: string; count: number; total_amount: number }) => (
              <div key={m.mode} className="bg-white rounded-lg shadow-sm border p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    {m.mode === 'upi' ? (
                      <Wallet className="h-8 w-8 text-blue-600" />
                    ) : m.mode === 'qr' ? (
                      <Shield className="h-8 w-8 text-purple-600" />
                    ) : (
                      <CreditCard className="h-8 w-8 text-emerald-600" />
                    )}
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-gray-500 uppercase">{m.mode.replaceAll('_',' ').toUpperCase()}</p>
                    <p className="text-2xl font-bold text-gray-900">{m.count}</p>
                    <p className="text-xs text-gray-500">{formatAmount(m.total_amount)} total</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Table */}
      <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('id')}
                >
                  <div className="flex items-center space-x-1">
                    <span>ID</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Order ID
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('user_account_name')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Name</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('user_mobile')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Phone</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('amount')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Amount</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  UTR
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Proof Image
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('status')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Request Type</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('mode')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Deposit Mode</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('status')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Status</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Reviewed
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Action
                </th>
                <th 
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort('created_at')}
                >
                  <div className="flex items-center space-x-1">
                    <span>Created At</span>
                    <ArrowUpDown className="w-3 h-3" />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredRecords.map((record, index) => (
                <tr key={`${record.request_type || 'manual'}-${record.gateway || 'none'}-${record.id}`} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {record.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900">
                    {record.gateway_order_id || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <div className="flex items-center">
                      <User className="w-4 h-4 text-gray-400 mr-2" />
                      {record.user_account_name || '-'}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600">
                    <div className="flex items-center">
                      <Phone className="w-4 h-4 text-gray-400 mr-2" />
                      {record.user_mobile}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <div className="flex items-center">
                      <IndianRupee className="w-4 h-4 text-gray-400 mr-2" />
                      {formatAmount(Number(record.amount))}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <div className="flex items-center">
                      <Hash className="w-4 h-4 text-gray-400 mr-2" />
                      <span className="font-mono text-xs">{record.utr_number}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {(record.screenshot_url || record.screenshot) ? (
                      <button
                        onClick={() => window.open((record.screenshot_url || record.screenshot) as string, '_blank')}
                        className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transition-colors"
                        title="View proof image"
                      >
                        <Eye className="w-3.5 h-3.5" />
                        View
                      </button>
                    ) : (
                      <span className="text-gray-400 text-xs">-</span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    Credit
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <div className="flex items-center">
                      <CreditCard className="w-4 h-4 text-blue-500 mr-2" />
                      {record.request_type === 'gateway'
                        ? (record.gateway || record.mode).toUpperCase()
                        : record.mode.toUpperCase()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(record.status)}`}>
                      {getStatusIcon(record.status)}
                      <span className="ml-1">
                        {record.request_type === 'gateway'
                          ? (record.gateway_status || record.status)
                          : record.status}
                      </span>
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {record.reviewed_by_role ? (
                      <div className="flex items-center">
                        <User className="w-4 h-4 text-gray-400 mr-2" />
                        {record.reviewed_by_role}
                      </div>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    {record.status === 'pending' && record.request_type !== 'gateway' ? (
                      <div className="flex space-x-2">
                        <button onClick={() => dispatch(reviewManualDeposit({ id: record.id, status: 'approved', admin_notes: 'Approved' }))}
                          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs">
                          Approve
                        </button>
                        <button onClick={() => dispatch(reviewManualDeposit({ id: record.id, status: 'rejected', rejection_reason: 'Invalid UTR' }))}
                          className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-3 py-1 rounded text-xs">
                          Reject
                        </button>
                      </div>
                    ) : record.request_type === 'gateway' && record.gateway === 'payxmint_v2' && record.status !== 'approved' ? (
                      <div className="flex flex-wrap gap-2">
                        <button
                          type="button"
                          onClick={async () => {
                            const result = await dispatch(
                              recheckPayxMintV2Payment(record.id)
                            );

                            if (recheckPayxMintV2Payment.fulfilled.match(result)) {
                              const data = result.payload;
                              const warnings = Array.isArray(data?.warnings)
                                ? data.warnings.join('\n')
                                : '';

                              window.alert(
                                `Payment ID: ${record.id}\n` +
                                `Gateway status: ${data?.gateway?.status || 'unknown'}\n` +
                                `Order verified: ${data?.order_verified ? 'Yes' : 'No'}\n` +
                                `Amount verified: ${data?.amount_verified ? 'Yes' : 'No'}\n` +
                                `Gateway success verified: ${data?.verified_success ? 'Yes' : 'No'}\n` +
                                `Wallet credited: No\n` +
                                (warnings ? `Warnings:\n${warnings}` : '')
                              );
                            } else {
                              window.alert(
                                String(
                                  result.payload ||
                                  'Unable to verify PayxMint V2 payment.'
                                )
                              );
                            }
                          }}
                          className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1 rounded text-xs"
                        >
                          Verify Payment
                        </button>

                        <button
                          type="button"
                          onClick={async () => {
                            if (!window.confirm(
                              `Approve recovery for payment ${record.id}? Approval does not credit the wallet.`
                            )) return;

                            const result = await dispatch(
                              approvePayxMintV2Recovery(record.id)
                            );

                            if (approvePayxMintV2Recovery.fulfilled.match(result)) {
                              window.alert(
                                `Approval recorded for payment ${record.id}. Wallet NOT credited.`
                              );
                            } else {
                              window.alert(String(
                                result.payload || 'Recovery approval rejected.'
                              ));
                            }
                          }}
                          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs"
                        >
                          Approve Recovery
                        </button>

                        <button
                          type="button"
                          onClick={async () => {
                            if (!window.confirm(
                              `FINAL CONFIRMATION: Recover wallet for payment ${record.id}? This may credit real money.`
                            )) return;

                            const result = await dispatch(
                              recoverPayxMintV2Wallet(record.id)
                            );

                            if (recoverPayxMintV2Wallet.fulfilled.match(result)) {
                              const data = result.payload;
                              window.alert(
                                `Payment ${record.id}: ` +
                                String(data?.outcome || data?.status || 'Request completed')
                              );
                              refreshDeposits();
                              dispatch(fetchManualDepositsStats());
                            } else {
                              window.alert(String(
                                result.payload || 'Wallet recovery rejected.'
                              ));
                            }
                          }}
                          className="bg-amber-600 hover:bg-amber-700 text-white px-3 py-1 rounded text-xs"
                        >
                          Recover Wallet
                        </button>
                      </div>
                    ) : record.request_type === 'gateway' && record.gateway === 'payxmint' && record.status !== 'approved' ? (
                      <div className="flex space-x-2">
                        {record.status === 'pending' && (
                          <button
                            onClick={async () => {
                              await dispatch(verifyPayxMintPayment(record.id));
                              refreshDeposits();
                              dispatch(fetchManualDepositsStats());
                            }}
                            className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1 rounded text-xs"
                          >
                            Verify Payment
                          </button>
                        )}

                        <button
                          onClick={async () => {
                            const utr = window.prompt(
                              'Enter the verified UTR / RRN for this payment:'
                            );

                            if (!utr || !utr.trim()) {
                              return;
                            }

                            const reason = window.prompt(
                              'Enter the reason for manually approving this gateway payment:'
                            );

                            if (!reason || !reason.trim()) {
                              return;
                            }

                            const confirmed = window.confirm(
                              `Manually approve ₹${Number(record.amount).toFixed(2)} with UTR ${utr.trim()}? This will credit the player wallet.`
                            );

                            if (!confirmed) {
                              return;
                            }

                            const result = await dispatch(
                              manualApproveGatewayPayment({
                                id: record.id,
                                utr: utr.trim(),
                                reason: reason.trim(),
                              })
                            );

                            if (manualApproveGatewayPayment.fulfilled.match(result)) {
                              window.alert('Gateway payment manually approved successfully.');

                              refreshDeposits();
                              dispatch(fetchManualDepositsStats());
                            } else {
                              window.alert(
                                String(
                                  result.payload ||
                                  'Unable to manually approve gateway payment.'
                                )
                              );
                            }
                          }}
                          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs"
                        >
                          Manual Approve
                        </button>
                      </div>
                    ) : (
                      <span className="text-gray-500">No Action</span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {formatDate(record.created_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex flex-col gap-3 border-t border-gray-200 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="text-sm text-gray-500">
            Showing {items.length} of {count} deposits
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <select
              value={pageSize}
              disabled={false}
              onChange={(event) => {
                setPageSize(Number(event.target.value));
                setPage(1);
              }}
              className="rounded border border-gray-300 bg-white px-3 py-2 text-sm"
              aria-label="Deposits per page"
            >
              {[10, 25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size} per page
                </option>
              ))}
            </select>

            <button
              type="button"
              disabled={!previous}
              onClick={() =>
                setPage((value) => Math.max(1, value - 1))
              }
              className="rounded border border-gray-300 px-3 py-2 text-sm text-gray-700 disabled:cursor-not-allowed disabled:opacity-40"
            >
              Previous
            </button>

            <span className="rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white">
              Page {page}
            </span>

            <button
              type="button"
              disabled={!next}
              onClick={() =>
                setPage((value) => value + 1)
              }
              className="rounded border border-gray-300 px-3 py-2 text-sm text-gray-700 disabled:cursor-not-allowed disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositRequest;
